import { Bot, Loader2, X } from 'lucide-react';
import type { FC, JSX } from 'react';
import { AllCall } from '../../services/api/calls/callsApi';
import { useGetConversationDetails } from '../../services/query/calls/conversations';

interface CallDetailsModalProps {
    call: AllCall;
    onClose: () => void;
}

const CallDetailsModal: FC<CallDetailsModalProps> = ({ call, onClose }): JSX.Element => {

  const { data: conversationDetails, isLoading } = useGetConversationDetails(+call.id);

    return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-3xl max-h-[80vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between">
          <div>
            <h3 className="text-xl font-bold text-gray-900">Call Details</h3>
            <p className="text-sm text-gray-600">{call?.user_name}</p>
          </div>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 rounded-lg">
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          {/* Call Info */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Start Time</label>
              <p className="text-gray-900">{new Date(call?.start_time || '').toLocaleString()}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">Duration</label>
              <p className="text-gray-900">
                {call.duration_seconds ? `${Math.floor(call.duration_seconds / 60)}m ${call.duration_seconds % 60}s` : 'N/A'}
              </p>
            </div>
            {/* <div>
              <label className="text-sm font-medium text-gray-700">Type</label>
              <p className="text-gray-900 capitalize">{call.type}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">Purpose</label>
              <p className="text-gray-900 capitalize">{conversationDetails?.purpose}</p>
            </div> */}
          </div>

          {/* AI Summary */}
          {call.summary && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h4 className="font-semibold text-blue-900 mb-2 flex items-center">
                <Bot className="w-5 h-5 mr-2" />
                AI Summary
              </h4>
              <p className="text-blue-800">{call.summary}</p>
            </div>
          )}

          {/* Conversation Transcript */}
          {!isLoading ? (
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Conversation Transcript</h4>
              <div className="space-y-3">
                {conversationDetails?.messages?.length ? (
                  conversationDetails.messages.map((message, index) => (
                    <div
                      key={message.id || index}
                      className={`flex ${message.speaker === 'user' ? 'justify-start' : 'justify-end'}`}
                    >
                      <div
                        className={`max-w-[70%] rounded-lg p-4 ${
                          message.speaker === 'user'
                            ? 'bg-gray-100 text-gray-900'
                            : 'bg-green-600 text-white'
                        }`}
                      >
                        <p className="text-sm font-medium mb-1">
                          {message.speaker === 'user' ? 'User' : 'AI Assistant'}
                        </p>
                        <p className="text-sm">{message.text}</p>
                        {/* {message.intent && (
                          <p className="text-xs mt-2 opacity-75">
                            Intent: {message.intent} ({Math.round((message.confidence || 0) * 100)}%)
                          </p>
                        )} */}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="space-y-2 text-center text-gray-500">No transcript available.</div>
                )}
              </div>
            </div>
          ) : (<Loader2 className="w-6 h-6 animate-spin text-green-600" />)}
        </div>
      </div>
    </div>
  );
};

export default CallDetailsModal;